// TODO: Now that old MyCars is gone the stuff in this file may be able to b moved to getDocumentOnHandlers
// We intentionally did not use event delegation here to get around stopPropagation() due to an old MyCars thing

/*
	This section is for handling:
	$(selectors[selector]).on(events,handler);
*/
const getSelectorOnHandlers = ({ link, video }) => [
	{
		// US358331: handle ws-contact 'get directions' button as a get directions link event
		// TODO: This can probably go in getDocumentOnHandlers but we should test
		// Perhaps it was set up like this due to some OSIRIS thing or something.
		// Maybe the eventDelegation won't work. Not sure.
		event: 'submit',
		selector: 'getDirectionsForm',
		handler: link.getDirections
	},
	// TODO: The three below video events can probably go in getDocumentOnHandlers
	{
		// Fires when play is clicked on HTML5 video
		event: 'play',
		selector: 'video',
		handler: video.play
	},
	{
		event: 'timeupdate',
		selector: 'video',
		handler: video.milestones.track
	},
	{
		event: 'ended',
		selector: 'video',
		handler: video.milestones.complete
	}
];

export default getSelectorOnHandlers;
